export enum MintingStatusE {
  Active,
  Scheduled,
  Closed,
}
